// removed by extract-text-webpack-plugin
module.exports = {"colors":"\"styles/colors.css\"","primary":"#492172","header":"_1rp1","body":"_3Z6J"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/WholesalerPortal/WholesalerPortal.scss
// module id = CSMB
// module chunks = 0